module.exports = __webpack_public_path__ + "img/FAQs-pana-rosa.86fe9e16.png";